import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-recaptcha-attribution',
  standalone: true,
  templateUrl: './recaptcha-attribution.component.html',
  styleUrls: ['./recaptcha-attribution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecaptchaAttributionComponent {
}
